module.exports = __webpack_public_path__ + "static/media/team.057e28c9.jpg";